export { default } from "www/pages/investors/Investors";
